<div class="row align-items-center justify-content-between">
  <div class="col-auto">
    <h3>Envio lote</h3>
  </div>

  <div class="col-auto">
    <button class="btn btn-secondary" type="button" (click)="baixarExemploCertidao()" placement="bottom"
        ngbTooltip="Exporta um arquivo JSON de exemplo para o envio de um lote certidão CADIN.">
      <i class="fa fa-file"></i> Exemplo de certidão CADIN
    </button>

    <button class="btn btn-secondary" type="button" (click)="limpar()" placement="bottom">
      <i class="fa fa-file"></i> Limpar
    </button>

    <button class="btn btn-primary" (click)="voltar()" type="button">Voltar</button>

    <button *ngIf="!enviado" [disabled]="!loteOperacoesForm.valid" type="button" (click)="onSubmit()"
      class="btn btn-primary" type="button">Enviar
    </button>
  </div>
</div>
<div class="col">
  <p>Envie um arquivo para importação, certidão CADIN para a modalidade {{nomeModalidade}}.</p>
</div>
<div class="container">
  <form [formGroup]="loteOperacoesForm" (validSubmit)="onSubmit()">

    <div class="row">
      <div class="bn-form-group col-md-6">
        <label class="form-label" for="arquivo">Arquivo:</label>
        <div id="customFile">
          <input class="form-control" type="file" accept=".json" id="arquivo" (change)="onFileChange($event)" #fileInput [disabled]="loteEnviado" formControlName="arquivo"/>
        </div>
        <label class="form-label arquivo-selecionado" *ngIf="arquivo?.tipoConteudo">Arquivo de {{labelTipoConteudo}} selecionado</label>
      </div>
    </div>
    <br>
  </form>
</div>

<div *ngIf="operacoes?.length > 0 && ocorrencias?.length == 0" class="erros-upload">
  <div class="row">
    <div class="col">
      <h4>Envio de lote Certidão</h4>
    </div>

  </div>
</div>

<div *ngIf="ocorrencias?.length > 0" class="erros-upload">
  <div class="row">
    <div class="col">
      <h4>Erros no envio de lote CADIN</h4>
    </div>
  </div>
</div>

<div>
  <div class="container" *ngIf="ocorrencias?.length > 0">
    <div class="table-responsive">
      <table class="table-striped table-bordered">
        <thead>
          <tr>

            <th class="text-center">
              Erro(s) encontrado(s)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let ocorrencia of ocorrencias">

              <td width="80%">
                  {{ ocorrencia.mensagem }}
              </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="obs-erro">Não foi possível realizar a importação da certidão CADIN do arquivo informado.</p>
  </div>
</div>

<bn-loading-overlay></bn-loading-overlay>
